import React, { useRef, useEffect, useImperativeHandle } from 'react';
import SunEditor, { buttonList } from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import plugins from 'suneditor/src/plugins';

const CustomSunEditor = React.forwardRef((props, ref) => {
  const { defaultContents, ...rest } = props;

  /**
   * @type {React.MutableRefObject<SunEditor>} get type definitions for editor
   */
  const editor = useRef();

  // The sunEditor parameter will be set to the core suneditor instance when this function is called
  const getSunEditorInstance = (sunEditor) => {
    editor.current = sunEditor;
  };

  useEffect(() => {
    editor.current.setContents(defaultContents);
  }, [defaultContents]);

  useImperativeHandle(ref, () => ({
    getContents: () => editor.current.getContents()
  }));

  return <SunEditor plugins={plugins} buttonList={buttonList.formatting} getSunEditorInstance={getSunEditorInstance} ref={editor} {...rest} />;
});
export default CustomSunEditor;
